import { render, staticRenderFns } from "./package-list.vue?vue&type=template&id=924b14a4&scoped=true"
import script from "./package-list.vue?vue&type=script&lang=js"
export * from "./package-list.vue?vue&type=script&lang=js"
import style0 from "./package-list.vue?vue&type=style&index=0&id=924b14a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924b14a4",
  null
  
)

export default component.exports